import axios from "axios"

import { urlToBlob } from "./std/files"

export async function uploadFileToStorage(
  presignedPutUrl: string,
  file: File | Blob,
  onProgress?: (progress: number) => void,
) {
  await axios.put(presignedPutUrl, file, {
    headers: {
      "Content-Type": file.type,
    },
    timeout: 5 * 60 * 1000,
    onUploadProgress: (event) => {
      const progress = Math.round((event.loaded * 100) / (event.total ?? 1))
      onProgress?.(progress)
    },
  })
}

export async function uploadFileFromUrlToStorage(
  presignedPutUrl: string,
  fileUrl: string,
  onProgress?: (progress: number) => void,
) {
  const file = await urlToBlob(fileUrl)
  await uploadFileToStorage(presignedPutUrl, file, onProgress)
}

export async function uploadBytesToStorage(
  presignedPutUrl: string,
  data: Uint8Array,
  mimeType: string,
  onProgress?: (progress: number) => void,
) {
  const blob = new Blob([new Uint8Array(data)], { type: mimeType })
  await uploadFileToStorage(presignedPutUrl, blob, onProgress)
}
